import { render, staticRenderFns } from "./myAct.vue?vue&type=template&id=8309a51c&scoped=true&"
import script from "./myAct.vue?vue&type=script&lang=js&"
export * from "./myAct.vue?vue&type=script&lang=js&"
import style0 from "./myAct.vue?vue&type=style&index=0&id=8309a51c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8309a51c",
  null
  
)

export default component.exports